import { useEffect } from 'react';

const SITE_URL = 'https://cuponeo.co';
const DEFAULT_OG_IMAGE = `${SITE_URL}/imagenes/cuponeo-og.png`;
const SITE_NAME = 'Cuponeo';
const SUFFIX = ' | Cuponeo — Cupones de Descuento en Colombia';
const DEFAULT_DESC = 'Los mejores cupones de descuento en Colombia. Gastronomia, belleza y spa, viajes, salud, cursos y mas en Cuponeo.';

/**
 * Hook de SEO: titulo, descripcion y metadatos OG/Twitter por pagina.
 *
 * @param {string} title - Titulo de la pagina (sin sufijo)
 * @param {string} [description] - Meta descripcion
 * @param {string} [image] - URL de imagen OG (fallback: cuponeo-og.png)
 */
export default function useSEO(title, description = DEFAULT_DESC, image = DEFAULT_OG_IMAGE) {
  useEffect(() => {
    const fullTitle = title ? `${title}${SUFFIX}` : `${SITE_NAME}${SUFFIX}`;
    document.title = fullTitle;

    const setMeta = (selector, attr, value) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        const [key, val] = selector.replace('meta[', '').replace(']', '').split('=');
        el.setAttribute(key, val.replaceAll('"', ''));
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[property="og:title"]', 'content', fullTitle);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:image"]', 'content', image);
    setMeta('meta[property="og:url"]', 'content', SITE_URL + window.location.pathname);
    setMeta('meta[name="twitter:title"]', 'content', fullTitle);
    setMeta('meta[name="twitter:description"]', 'content', description);
    setMeta('meta[name="twitter:image"]', 'content', image);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = SITE_URL + window.location.pathname;
  }, [title, description, image]);
}
